module.exports = __webpack_public_path__ + "img/camylla-battani.4665d5bd.png";